import { ToolEngagementActionTypeEnum } from '@reach/shared-types/tool-engagement';
import clsx from 'clsx';
import { CalendarCheck2, CircleOff, Link2, type LucideIcon } from 'lucide-react';
import styles from './EngagementAction.module.css';
import { ENGAGEMENT_ACTION_COPY, ENGAGEMENT_OUTCOME_OPTIONS } from './engagement-action-copy';

const OUTCOME_ICONS = {
  '': CircleOff,
  [ToolEngagementActionTypeEnum.ENGAGEMENT_CREATED]: CalendarCheck2,
  [ToolEngagementActionTypeEnum.ENGAGEMENT_LINK_CREATED]: Link2,
} satisfies Record<(typeof ENGAGEMENT_OUTCOME_OPTIONS)[number]['value'], LucideIcon>;

interface EngagementOutcomeCardsProps {
  selectedValue: string | null;
  onChange: (value: string) => void;
}

export const EngagementOutcomeCards = ({ selectedValue, onChange }: EngagementOutcomeCardsProps) => (
  <fieldset className={styles.outcomePicker}>
    <legend>{ENGAGEMENT_ACTION_COPY.outcomeLegend}</legend>
    <div className={styles.outcomeCards}>
      {ENGAGEMENT_OUTCOME_OPTIONS.map(({ value, title, description }) => {
        const Icon = OUTCOME_ICONS[value];
        return (
          <label
            key={value || 'none'}
            className={clsx(styles.outcomeCard, selectedValue === value && styles.outcomeCardSelected)}>
            <input
              type="radio"
              name="tool-engagement-action"
              value={value}
              checked={selectedValue === value}
              onChange={event => onChange(event.target.value)}
            />
            <Icon aria-hidden="true" />
            <strong>{title}</strong>
            <span className={styles.outcomeDescription}>{description}</span>
          </label>
        );
      })}
    </div>
  </fieldset>
);
